import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './langs/en'
import tw from './langs/tw'
import zh from './langs/zh'

Vue.use(VueI18n)

// 将数据配置好
const messages = {
  en,
  zh,
  tw
}
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js